import data from "../../../../../src/BranchName/BranchName.docs.json";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  DeprecationBanner,
  React
};